<script>
    import { mapState } from 'vuex';

    export default {
        name: 'footer-component',
        computed: {
            ...mapState([
                'isLoggedIn',
                'loggedUser',
                'isDarkMode'
            ]),
            currentPath() {
                return this.$route.path;
            }
        },
        methods: {
            goToMapGoogle() {
				const baseUrl = 'https://www.google.com/maps/@';
				const params = '7.0769945,125.6209446,3a,90y,343.63h,91.02t';
				const dataParams = '!3m7!1e1!3m5!1sQIdNID1z6fIWtcbzl6hdDg!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D-1.016592435331333%26panoid%3DQIdNID1z6fIWtcbzl6hdDg%26yaw%3D343.62537538103453!7i16384!8i8192';
				const url = `${baseUrl}${params}/data=${dataParams}?entry=ttu`;
				window.open(url, '_blank');
			},
            goToFacebook(){
                window.open(`https://www.facebook.com/tennyenterprisesinc`, '_blank');
            },
            sendEmail(){
                window.location.href = "mailto:orders@tennyinc.com";
            },
            callOption(number){
                window.location.href = `tel:${number}`;
            }
        }
    };
</script>